export default __webpack_public_path__ + "static/media/pa.b291eeb8.svg";